import { TYPE_BUTTONS } from '../../../../constans';
import { Row } from '../../../Basic/Blocks';
import { Button } from '../../../Basic/Buttons';
import { Input } from '../../../Basic/Inputs';
import { Text } from '../../../Basic/WrapsStyle';
import MarketContextMenu from './MarketContextMenu';
import styles from './styles.module.scss';

const MarketsSearch = ({
  market,
  search,
  count = 0,
  selectTab,
  productsSelect = [],
  setSearch,
  setCheckAll,
  setProductsSelect,
  onArchive = (_) => _,
  onStopbrand = () => _,
  updateStocks = (_) => _,
  updatePrices = (_) => _,
  toBasket = () => { },
  updateImages = () => { },
  onDelete = () => { },
}) => {
  console.log(selectTab);
  return (
    <>
      <Row className={styles.row_input}>
        {Object.keys(productsSelect).length > 0 ? (
          <Row className={styles.row_select}>
            <div className={styles.t_select}>Выбрано товаров: {`${Object.keys(productsSelect).length}`}</div>
            <Button
              type={TYPE_BUTTONS.RED}
              style={{ marginLeft: '15px', marginRight: '15px' }}
              onClick={() => {
                setCheckAll(false);
                setProductsSelect({});
              }}
            >
              Очистить выбор
            </Button>
            <MarketContextMenu
              market={market}
              isArchive={selectTab === 'archive'}
              isStopbrand={selectTab === 'stopbrand'}
              isBasket={selectTab === 'basket'}
              archiveProducts={() => onArchive(Object.keys(productsSelect), true)}
              UnarchiveProducts={() => onArchive(Object.keys(productsSelect), false)}
              stopbrandProducts={() => onStopbrand(Object.keys(productsSelect), true)}
              UnstopbrandProducts={() => onStopbrand(Object.keys(productsSelect), false)}
              updateStocks={(state = false) => updateStocks(Object.keys(productsSelect), state)}
              updatePrices={() => updatePrices(Object.keys(productsSelect))}
              toBasket={(state) => toBasket(Object.keys(productsSelect), state)}
              updateImages={() => updateImages(Object.keys(productsSelect))}
              onDelete={() => onDelete(Object.keys(productsSelect))}
            />
          </Row>
        ) : (
          <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
        )}
      </Row>
      <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>
    </>
  );
};

export default MarketsSearch;
